<template>
  <div class="capability">
    <div class="banner">
      <div class="title-blue">联盟能力</div>
    </div>
    <div class="container">
      <div class="nav">
        <div v-for="(capability, index) in capabilities" :key="index">
          <div class="item">
            <h3 :class="capability.type">
              {{ capability.title }}
            </h3>
            <div v-for="(item, itemIndex) in capability.items" :key="itemIndex">
              <h4 :class="currentType === item.type ? `${item.type} ${item.type}-active` : item.type">
                <a @click="getCapabilityDesc(item.type)">{{ item.title }}</a>
                <i class="el-icon-arrow-right"></i>
              </h4>
              <ul>
                <li
                  v-for="(feature, featureIndex) in item.features"
                  :key="featureIndex">
                  <div>{{ featureIndex+1 }}.</div><div>{{ feature.title }}</div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="main">
        <h3> {{ capabilityInfo.title }} </h3>
        <div v-for="(info, index) in capabilityInfo.features" :key="index">
          <p>{{ index + 1}}. {{ info.title }}</p>
          <pre class="pre-content">{{ info.desc.trim() }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { capabilities } from '@/utils/helper.js'
export default {
  name: 'Capability',
  data () {
    return {
      capabilities,
      capabilityInfo: [],
      currentType: ''
    }
  },
  mounted () {
    this.getCapabilityDesc('qax-basic')
  },
  methods: {
    formatData () {
      let capabilityObj = {};
      this.capabilities.forEach(capability => {
        capability.items.forEach(item => {
          capabilityObj[item.type] = {
            title: item.title,
            features: item.features
          }
        })
      })
      return capabilityObj;
    },
    getCapabilityDesc (type) {
      this.capabilityInfo = this.formatData()[type];
      this.currentType = type;
      // console.log('info', this.capabilityInfo);
    }
  }
}
</script>

<style lang="scss" scoped>
  .capability {
    margin-bottom: -73px;
    .banner {
      background: url(~@/assets/images/img-bg.png) right top no-repeat #EBF1FF;
      height: 320px;
      padding-top: 48px;
    }
    .container {
      width: 1200px;
      margin: 0 auto;
      padding: 10px;
      overflow: hidden;
      position: relative;
      top: -127px;
    }
    .nav {
      width: 288px;
      // height: 807px;
      float: left;
      background: #FFFFFF;
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);
      h3 {
        height: 64px;
        line-height: 64px;
        font-size: 24px;
        color: #FFFFFF;
        text-align: left;
        padding-left: 32px;
        background: url(~@/assets/images/capability-nav-bg.png) right bottom no-repeat;
      }
      h4 {
        height: 53px;
        font-size: 16px;
        line-height: 53px;
        text-align: left;
        padding-left: 32px;
        position: relative;
        background: #FBFBFB;
        i {
          position: absolute;
          top: 18px;
          right: 24px;
        }
      }
      li {
        font-size: 14px;
        list-style-type: decimal;
        color: #999999;
        text-align: left;
        line-height: 24px;
        padding: 8px 32px;
        display: flex;
      }
      .basic {
        background-color: #0C63D7;
      }
      .advance {
        background-color: #D8B84E;
      }
      .qax-basic {
        color: #0C63D7;
        cursor: pointer;
      }
      .qax-basic-active {
        background-color: #EBF1FF;
      }
      .qax-advance {
        color: #A48726;
        cursor: pointer;
      }
      .qax-advance-active {
        background-color: #FFF5D5;
      }
      .tjym-advance {
        background-color: #FBFBFB;
        color: #A48726;
        cursor: pointer;
      }
      .tjym-advance-active {
        background-color: #FFF5D5;
      }
    }
    .main {
      width: 876px;
      float: right;
      background: #FFFFFF;
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.08);
      padding: 16px;
      h3 {
        height: 100px;
        line-height: 100px;
        background: #FBFBFB;
        font-size: 24px;
        color: #333333;
        text-align: center;
      }
      div {
        padding: 27px 32px 0 32px;
      }
      p {
        font-size: 14px;
        line-height: 28px;
        text-align: left;
      }
      .pre-content {
        font-size: 14px;
        color: #666666;
        text-align: left;
        line-height: 28px;
        word-break: break-word;
        white-space: pre-wrap;
      }
    }
  }
</style>
